module.exports = __webpack_public_path__ + "static/app-5-c1d4de9011998dba83586d649734ae77.png";